module.exports = __webpack_public_path__ + "static/media/burger.ab4530c7.svg";